import { createContext } from "react";
import type usePatientIdentityById from "src/hooks/data/load/usePatientIdentityById";

export interface IPatientIdentityContext extends ReturnType<
    typeof usePatientIdentityById
> {}

export const PatientIdentityContext = createContext<IPatientIdentityContext>({
    data: undefined,
    error: undefined,
    loading: false,
    validating: false,
    mutate: async () => undefined,
    refresh: async () => undefined,
});

export default PatientIdentityContext;
